import React, { useState, useEffect, memo } from 'react'
import PropTypes from 'prop-types'
import { Route, Redirect } from 'react-router-dom'
import { Link } from 'react-router-dom';
import { ServerConfig } from 'config'
import axios from 'axios'
import { useDispatch, useSelector } from 'react-redux'
import { logout } from '../../redux/actions/auth.js'

import loading_gif from '../../assets/img/loading.gif'

import SortableTbl from "react-sort-search-table";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'
import { Typography, Grid, Hidden, Container } from '@material-ui/core'
import { ListGroup, ListGroupItem } from 'reactstrap';
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";

import Page from 'components/Page/Page'
import { getAllowedRoutes } from 'utils';
import _, { get } from 'lodash'
import NonPaginatedList from "../../components/EntryListAndEdit/NonPaginatedList";

const useStyles = makeStyles((theme) => ({}))


const Invoices = () => {
  const token = useSelector(state => state.auth.access_token)
  const classes = useStyles()

  const non_editable_fields = [
    ["id", "id", ""],
    ["number", "number", ""],
    ["tenant_id", "tenant_id", ""],
    ["ts_crated", "ts_created", "timestamp"],
    ["start_utc_timestamp", "start_utc_timestamp", "timestamp"],
    ["end_utc_timestamp", "end_utc_timestamp", "timestamp"],
    ["amount_microdollars", "amount_microdollars", ""]
    //["owner", "Owner", ""]
  ];

  const editable_fields = [];

  return (
    <>
      <NonPaginatedList
        list_get_url={`${ServerConfig.SERVER_URL}/admin/invoices`}
        detail_get_url={`${ServerConfig.SERVER_URL}/admin/invoices/`}
        detail_put_url={`${ServerConfig.SERVER_URL}/admin/invoices/`}
        add_new_url = {`${ServerConfig.SERVER_URL}/admin/invoices/`}

        column_names={["id", "number", "tenant_id", "edit"]}
        header_names={["id", "number", "tenant_id", ""]}

        optional_column_names={["ts_created", "start_utc_timestamp", "end_utc_timestamp", "amount_microdollars"]}
        optional_header_names={["ts_created", "start_utc_timestamp", "end_utc_timestamp", "amount_microdollars"]}

        filter_inputs={[
          {/*{
            'name': 'device_ids',
            'type': 'device_ids',
            'label': 'Devices:',
            'initial_value': undefined,
          },
          {
            'name': 'start_ts_utc',
            'type': 'utc_date_start',
            'label': 'Start-Date (incl.):',
            'initial_value': date_before_1_week
          },
          {'name': 'end_ts_utc', 'type': 'utc_date_end', 'label': 'End-Date (incl.):', 'initial_value': date_today}
          */}
        ]}

        editable_fields={editable_fields}
        non_editable_fields={non_editable_fields}
        //ledger_get_url = '/ledger/customer/'
        //show_machine_stats={true}
      />
    </>
  )
}

export default Invoices
